import {createRef, h} from "preact";
import {forwardRef} from "preact/compat";
import {useRef, useState} from "preact/hooks";
import './index.less';
import cx from "classnames";
import {useEffect} from "preact/hooks";
const Input = forwardRef(({className, suffix, placeholder, onInput:onFieldInput = () => {}, ...props}, ref = createRef()) => {
  delete props.class;
  const [focusStatus, setFocus] = useState(false);
  const timeout = useRef(null);
  const placeholderRef = useRef();
  const [placeholderStyle, setPlaceholderStyle] = useState({});
  const suffixRef = useRef();
  const [scrollStatus, setScrollStatus] = useState(false);
  /*useEffect(() => {
    let clearTimeoutNum = null;
    const setWidth = () => {
      placeholderRef.current.setAttribute('style','');
      const suffixWith = suffixRef.current.getBoundingClientRect().width;
      clearTimeout(clearTimeoutNum);
      clearTimeoutNum = setTimeout( () => {
        const placeholderElementWidth = placeholderRef.current.getBoundingClientRect().width;
        if (suffixWith) {
          setPlaceholderStyle({
            width: placeholderElementWidth - suffixWith - 24
          })
        }
      }, 200);
    };
    setWidth();
    window.addEventListener('resize', setWidth);
    return () => {
      window.removeEventListener('resize', setWidth);
    }
  }, []);*/
  useEffect(() => {
    if (focusStatus) {
      placeholderRef.current.childNodes[0].style.width = "auto";
      timeout.current = setTimeout(() => {
          const placeholderElementWidth = placeholderRef.current.getBoundingClientRect().width;
          const placeholderTextElementWidth = placeholderRef.current.childNodes[0].getBoundingClientRect().width
          if (placeholderTextElementWidth > placeholderElementWidth) {
            setScrollStatus(true);
          }
          clearTimeout(timeout.current);
        },
        300
      )
    } else {
      placeholderRef.current.childNodes[0].style.width = "100%";
      setScrollStatus(false);
      clearTimeout(timeout.current);
    }
  }, [focusStatus]);
  useEffect(() => {
    const focusHandle = () => {
      setFocus(true);
    }
    const blurHandle = () => {
      if (!ref.current.value) {
        setFocus(false);
      }
    }
    if (ref.current) {
      ref.current.addEventListener('focus', focusHandle);
      ref.current.addEventListener('blur', blurHandle);
    }
    return () => {
      if (ref.current) {
        ref.current.removeEventListener('focus', focusHandle);
        ref.current.removeEventListener('blur', blurHandle);
      }
    }
  }, [ref.current])
  const onInput = (e) => {
    props.onChange && props.onChange(e);
    onFieldInput(e);
    if (props.onChange) {
      if (props.value !== e.target.value) {
        e.target.value = props.value;
      }
    }
  }
  return <div className={cx('xfe_common_input_wrapper', className, props.disabled && 'disable')}>
    <div className={cx('xfe_common_input')}>
      <input ref={ref} type={'text'} onInput={onInput} {...props} data-focus-method={focusStatus ? 'focus' : ''}/>
      <span ref={placeholderRef} className={'xfe_common_input_placeholder'} style={placeholderStyle}
            onClick={() => ref.current.focus()}><span className={cx(scrollStatus && 'scroll')}>{placeholder}</span></span>
    </div>
    <span ref={suffixRef} className={'xfe_common_input_suffix'}>{suffix} </span>
  </div>

})

export default Input;
